import React, { useEffect, useState } from 'react';

const CONFIRMATION_TEXT = 'DELETE';

export default function DeleteAlertModal({
  alert,
  open,
  loading,
  onCancel,
  onConfirm,
}) {
  const [confirmation, setConfirmation] = useState('');

  useEffect(() => {
    if (open) setConfirmation('');
  }, [open, alert?.id]);

  if (!open || !alert) return null;

  const userLabel = alert.user
    ? `${alert.user.firstName || ''} ${alert.user.lastName || ''}`.trim() || alert.user.email
    : 'Unknown user';

  const canDelete = confirmation === CONFIRMATION_TEXT && !loading;

  return (
    <div
      className="fixed inset-0 bg-slate-900/40 backdrop-blur-xs flex items-center justify-center z-[9999] p-4"
      onClick={onCancel}
    >
      <div
        className="bg-white rounded-2xl max-w-md w-full p-6 border border-slate-100 shadow-xl flex flex-col gap-4"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="w-12 h-12 bg-rose-50 border border-rose-200 text-rose-600 rounded-full flex items-center justify-center text-xl">
          <i className="fas fa-triangle-exclamation" />
        </div>

        <div className="flex flex-col gap-2">
          <h2 className="font-bold text-slate-900 text-lg m-0">Delete alert permanently?</h2>
          <p className="text-sm text-slate-600 m-0">
            This will permanently delete the <strong>{alert.type?.replace(/_/g, ' ') || 'alert'}</strong>{' '}
            from <strong>{userLabel}</strong> and all related messages, recipients, and logs.
          </p>
          <p className="text-sm text-rose-700 m-0 font-medium">This action cannot be undone.</p>
        </div>

        <div>
          <label
            htmlFor="delete-alert-confirmation"
            className="block text-xs font-semibold text-slate-600 mb-2"
          >
            Type <span className="font-mono text-rose-700">{CONFIRMATION_TEXT}</span> to confirm
          </label>
          <input
            id="delete-alert-confirmation"
            type="text"
            value={confirmation}
            onChange={(e) => setConfirmation(e.target.value)}
            placeholder={CONFIRMATION_TEXT}
            autoComplete="off"
            className="w-full border border-slate-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-rose-200"
          />
        </div>

        <div className="flex gap-3 justify-end pt-1">
          <button
            type="button"
            onClick={onCancel}
            disabled={loading}
            className="px-4 py-2 border rounded-lg text-sm font-semibold text-slate-600 hover:bg-slate-50 disabled:opacity-60"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={() => onConfirm(confirmation)}
            disabled={!canDelete}
            className="px-4 py-2 bg-rose-600 text-white rounded-lg text-sm font-semibold hover:bg-rose-700 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? 'Deleting…' : 'Delete alert'}
          </button>
        </div>
      </div>
    </div>
  );
}
